import React, { Fragment } from 'react';
import { Edit } from 'react-admin';
import EventTabs from './Tabs';

const EventEdit = (props) => {
  return (
    <Fragment>
      <Edit
        title={`resources.event.titles.edit`}
        mutationMode="optimistic"
        {...props}
      >
        <EventTabs {...props} />
      </Edit>
    </Fragment>
  );
};

export default EventEdit;
